const Referee = require('@/tbs/model/to/Referee')
const referee = new Referee
/**
 * The Referee class acts as the view object for the referee.
 */
const tbs_model_vo_Referee = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Referee.prototype = {
    /* The view object name */
    name: 'referee',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmRefereeList',
            basePath: 'data.list',
            query: {
                accountId: 'organizationId',
                clientType: '(h5)',
            },
            rule: {
                id: 'id',
                organizationId: 'organizationId',
                name: 'name',
                firstLetter: '$nameInitials',
                avatarUrl: 'avatar',
                description: 'mobile',
                isInvited: '@userId',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmReferee',
            basePath: 'data.referee',
            rule: {
                id: 'id',
                organizationId: 'accountId',
                name: 'name',
                firstLetter: '$nameInitials',
                avatarUrl: 'avatar',
                phone: 'mobile',
                grade: '$refereeLevel',
                gradeLabel: 'refereeLevel',
                gradeIndex: '$refereeLevel',
                isInvited: '@userId',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateCrmReferee',
            basePath: '',
            rule: {
                accountId: 'organizationId',
                name: 'name',
                avatar: '$avatar,avatarUrl',
                mobile: 'phone',
                refereeLevel: '$grade',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateCrmReferee',
            basePath: '',
            rule: {
                id: 'id',
                accountId: 'organizationId',
                name: 'name',
                avatar: '$avatar,avatarUrl',
                mobile: 'phone',
                refereeLevel: '$grade',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateCrmRefereeStatus',
            basePath: '',
            rule: {
                id: 'id',
                accountId: 'organizationId',
                status: '(-2)',
            }
        },
        invite: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccountRefereeInvitation',
            method: 'GET',
            basePath: 'data',
            query: {
                refereeId: 'id',
            },
            rule: {
                id: 'id',
                name: 'name',
                role: '$id',
                organizationId: 'accountId',
                organizationName: 'accountName',
                organizationLogoUrl: 'accountLogo',
            }
        },
        accept: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AcceptCrmAccountRefereeInvitation',
            basePath: '',
            rule: {
                refereeId: 'id',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderRole: function() {
        return referee.localeProp('match-referee')
    },
    formatRefereeLevel: function(grade) {
        const gradeOptions = this.gradeOptions()
        for (let i = 0; i < gradeOptions.length; i++) {
            let gradeOption = gradeOptions[i]
            if (gradeOption.value == grade) {
                return gradeOption.label
            }
        }
    },
    renderGradeIndex: function(refereeLevel) {
        const gradeOptions = this.gradeOptions()
        for (let i = 0; i < gradeOptions.length; i++) {
            let gradeOption = gradeOptions[i]
            if (gradeOption.label == refereeLevel) {
                return i
            }
        }
        return 0
    },
    renderGrade: function(refereeLevel) {
        const gradeOptions = this.gradeOptions()
        for (let i = 0; i < gradeOptions.length; i++) {
            let gradeOption = gradeOptions[i]
            if (gradeOption.label == refereeLevel) {
                return gradeOption.value
            }
        }
    },
    formatAvatar: function(avatar, avatarUrl) {
        return avatar ? avatar : avatarUrl
    },
    renderFirstLetter: function(nameInitials) {
        return nameInitials ? nameInitials.substr(0, 1) : ''
    },
    gradeOptions: function() {
        const gradeList = []
        for (let i = 1; i < 13; i++) {
            gradeList.push({
                label: referee.localeProp('referee-grade-options-' + i), 
                value: i.toString()
            })
        }
        gradeList.push({
            label: referee.localeProp('referee-grade-options-0'), 
            value: '0'
        })
        return gradeList
    },
    localeProp: function(prop, parameters) {
        return referee.localeProp(prop, parameters)
    }
}

module.exports = tbs_model_vo_Referee